import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '@/apis'
import router from '../router'
import useWeb3 from '../utils/useWeb3'

export const useIndexStore = defineStore('index', () => {
  // 状态
  const token = ref(localStorage.getItem('token') || '')
  //当前授权额度
  const currentAuth = ref(0)
  //当前余额
  const currentBalance = ref(0)
  //地址
  const address = ref(localStorage.getItem('address') || '')
  //当前链
  const currentChain = ref('')

  // 用户信息
  const userInfo = ref(null)
  const inviteCode = ref(localStorage.getItem('inviteCode') || '')

  // 资产信息
  const assetInfo = ref(null)

  // 计算属性
  const isWalletInstalled = computed(() => {
    return typeof window !== 'undefined' && window.ethereum
  })

  const balance = computed(async () => {
    const balance = await useWeb3.mainContract.balanceOf(address.value)
    return balance
  })

  // 方法区
  const setToken = (newToken) => {
    token.value = newToken || ''
    if (!newToken) {
      localStorage.removeItem('token')
      router.push('/')
    } else {
      localStorage.setItem('token', newToken)
    }
  }

  const setAddress = (newAddress) => {
    address.value = newAddress || ''
    if (!newAddress) {
      localStorage.removeItem('address')
    } else {
      localStorage.setItem('address', newAddress)
    }
  }

  const setInvitationCode = (code) => {
    inviteCode.value = code || ''
    if (!code) {
      localStorage.removeItem('inviteCode')
    } else {
      localStorage.setItem('inviteCode', code)
    }
    userInfo.value = { ...(userInfo.value || {}), invitationCode: code }
  }

  const setCurrentBalance = (balance) => {
    currentBalance.value = balance
  }

  const setCurrentAuth = (auth) => {
    currentAuth.value = auth
  }
  const initWallet = async () => {
    //获取主合约余额
    const balance = await useWeb3.mainContract.balanceOf(address.value)
    setCurrentBalance(balance)
    //获取主合约授权额度
    const auth = await useWeb3.mainContract.getCurrentAuth(address.value)
    setCurrentAuth(auth)
  }

  const getUserInfo = async () => {
    const data = await api.address.info()
    userInfo.value = data
    assetInfo.value = data || {}
  }

  // 获取用户信息
  // const getUserInfo = async () => {
  //   const data = await api.home.userInfo()
  //   assetInfo.value = data.balance_list
  //   console.log(assetInfo.value,data);
  // }

  // 清除所有状态
  const clearAll = () => {
    token.value = ''
    address.value = ''
    currentBalance.value = 0
    currentAuth.value = 0
    //路由跳转到首页
    router.push('/')
  }

  // 格式化地址显示
  const formatAddress = computed(() => {
    if (!address.value) return ''
    return `${address.value.slice(0, 6)}...${address.value.slice(-4)}`
  })

  return {
    // 状态
    token,
    address,
    currentBalance,
    currentAuth,
    userInfo,
    assetInfo,
    inviteCode,

    // 计算属性
    isWalletInstalled,
    formatAddress,
    balance,
    currentChain,

    // 方法区
    setToken,
    setAddress,
    setInvitationCode,
    setCurrentBalance,
    setCurrentAuth,
    initWallet,
    clearAll,
    getUserInfo
  }
})
